"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogActions = void 0;
const react_1 = __importStar(require("react"));
const isString_1 = __importDefault(require("lodash/isString"));
const mui_1 = require("tss-react/mui");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const QButton_1 = __importDefault(require("components/QButton"));
const styles_1 = __importDefault(require("./styles"));
exports.dialogActions = {
    CLOSE: 'Close',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    KEYDOWN: 'KeyDown',
};
const BaseDialogComponent = (prop) => {
    var _a, _b, _c, _d, _e;
    return (<Dialog_1.default maxWidth="md" onClose={prop.dispatchDialogAction(exports.dialogActions.CLOSE)} onKeyPress={prop.dispatchDialogAction(exports.dialogActions.KEYDOWN)} aria-labelledby="dialogHoc-title" open>
    <DialogTitle_1.default id="dialogHoc-title" className={(_a = prop.classes) === null || _a === void 0 ? void 0 : _a.dialogTitleRoot}>
      <Typography_1.default variant="h6">
        {prop.dialog.title}
      </Typography_1.default>
      <IconButton_1.default aria-label="Close" className={(_b = prop.classes) === null || _b === void 0 ? void 0 : _b.dialogCloseButton} onClick={prop.dispatchDialogAction(exports.dialogActions.CLOSE)} size="large">
        <Close_1.default />
      </IconButton_1.default>
    </DialogTitle_1.default>
    <DialogContent_1.default className={(_c = prop.classes) === null || _c === void 0 ? void 0 : _c.dialogContentRoot}>
      <Typography_1.default variant="subtitle1" component="div" className={(_d = prop.classes) === null || _d === void 0 ? void 0 : _d.dialogContentText}>
        {prop.dialog.content}
      </Typography_1.default>
    </DialogContent_1.default>
    {prop.dialog.buttons && (<DialogActions_1.default className={(_e = prop.classes) === null || _e === void 0 ? void 0 : _e.dialogActionsRoot}>
        {prop.dialog.buttons.map((Btn, index) => {
                var _a;
                if ((0, isString_1.default)(Btn)) {
                    const variant = index === prop.dialog.buttons.length - 1 ? 'contained' : 'outlined';
                    return (<QButton_1.default id={`dialog_${Btn}`} key={Btn} className={(_a = prop.classes) === null || _a === void 0 ? void 0 : _a.dialogActionsButton} variant={variant} onClick={prop.dispatchDialogAction(Btn)}>
                {Btn}
              </QButton_1.default>);
                }
                return <Btn key={Btn} onClick={prop.dispatchDialogAction(Btn)}/>;
            })}
      </DialogActions_1.default>)}
  </Dialog_1.default>);
};
const StyledDialogComponent = (0, mui_1.withStyles)(BaseDialogComponent, styles_1.default);
exports.default = () => (WrappedComponent) => {
    const DialogHoc = (props) => {
        const [dialog, setDialogState] = (0, react_1.useState)(null);
        const setDialog = (0, react_1.useCallback)((title, content, callback, buttons) => {
            setDialogState({ title, content, callback, buttons });
        }, []);
        const clearDialog = (0, react_1.useCallback)(() => {
            setDialogState(null);
        }, []);
        const dispatchDialogAction = (0, react_1.useCallback)((action) => (event, reason) => {
            let dispatchAction = action;
            if (dispatchAction === exports.dialogActions.KEYDOWN && event.key === 'Enter') {
                dispatchAction = exports.dialogActions.ENTER;
            }
            else if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
                dispatchAction = exports.dialogActions.ESCAPE;
            }
            if (dispatchAction !== exports.dialogActions.KEYDOWN && (dialog === null || dialog === void 0 ? void 0 : dialog.callback)) {
                dialog.callback({ action: dispatchAction });
                clearDialog();
            }
        }, [dialog, clearDialog]);
        return (<>
        <WrappedComponent {...props} setDialog={setDialog}/>
        {dialog && (<StyledDialogComponent dialog={dialog} dispatchDialogAction={dispatchDialogAction}/>)}
      </>);
    };
    return DialogHoc;
};
